import { inject, observer } from 'mobx-react';
import moment from "moment";
import React from "react";
import { ArrowLeftCircle, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Monitor, Power, Smartphone } from "react-feather";
import Slider from 'react-slick';
import { Badge, Button, ButtonGroup, Card, CardBody, CardHeader, CardTitle, Col, Collapse, Modal, ModalBody, ModalFooter, ModalHeader, Row, UncontrolledTooltip } from 'reactstrap';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "../../assets/scss/pages/app-chat.scss";
import { history } from "../../history";
import Checkbox from "../../theme/@vuexy/checkbox/CheckboxesVuexy";
import Participant from "./components/Participant";
import PresenterControls from "./components/PresenterControls";
import Slide from "./components/CanvasSlide";
import Thumb from "./components/Thumb";
import Timer from "./components/Timer";
const mql = window.matchMedia(`(min-width: 992px)`)

@inject('presenterMeetingStore', 'sessionStore')
@observer
class PresenterMeetingRoomNew extends React.Component {
    state = {
        isCollapseControlOpen: false,
        participantCollapsed: true,
        notesCollapsed: true,
        showStartModal: false,
        showEndModal: false,
        audioOpted: false,
        device: 'desktop',
        brushColor: "#28c76f"
    }

    componentDidMount() {
        const { presenterMeetingStore, match, sessionStore } = this.props;
        const { meetingId } = match.params;
        const { authUser } = sessionStore;
        presenterMeetingStore.loadMeeting(authUser.uid, meetingId);
        //presenterMeetingStore.comeOnline(authUser.uid);
    }

    startMeeting = () => {
        const { presenterMeetingStore, sessionStore } = this.props;
        const {audioOpted} = this.state;
        presenterMeetingStore.startMeeting(sessionStore.authUser, audioOpted);
        this.toggleStartModal();
    }

    endMeeting = () => {
        const { presenterMeetingStore, sessionStore } = this.props;
        presenterMeetingStore.endMeeting(sessionStore.authUser);
        presenterMeetingStore.goToSlide(sessionStore.authUser, 0);
        this.toggleEndModal();
    }

    // mounted = false
    handleUserSidebar = status => {
        if (status === "open") {
            this.setState({
                userProfile: true
            })
        } else {
            this.setState({
                userProfile: false
            })
        }
    }

    handleActiveChat = (id, user, chats) => {
        this.setState({
            activeChatID: id,
            activeUser: user,
            activeChat: chats
        })
    }

    UNSAFE_componentWillMount() {
        mql.addListener(this.mediaQueryChanged)
    }

    componentWillUnmount() {
        mql.removeListener(this.mediaQueryChanged)
    }

    onSetSidebarOpen = open => {
        this.setState({ sidebarOpen: open })
    }

    mediaQueryChanged = () => {
        this.setState({ sidebarDocked: mql.matches, sidebarOpen: false })
    }

    next = () => {
        if (this.animating) return;
        const { presenterMeetingStore, sessionStore } = this.props;
        const { presentation } = presenterMeetingStore.meeting;
        const { currentSlide } = presentation;
        if (presentation.slides.length > currentSlide) {
            presenterMeetingStore.goToSlide(sessionStore.authUser, currentSlide + 1);
            //this.slider.slickGoTo(currentSlide +1);
        }
    }

    previous = () => {
        if (this.animating) return;
        const { presenterMeetingStore, sessionStore } = this.props;
        const { presentation } = presenterMeetingStore.meeting;
        const { currentSlide } = presentation;
        if (currentSlide > 0) {
            presenterMeetingStore.goToSlide(sessionStore.authUser, currentSlide - 1);
            //this.slider.slickGoTo(currentSlide -1);
        }
    }

    goToIndex = newIndex => {
        if (this.animating) return;
        const { presenterMeetingStore, sessionStore } = this.props;
        presenterMeetingStore.goToSlide(sessionStore.authUser, newIndex);
        //this.slider.slickGoTo(newIndex);
    }

    toggleStartModal = () => {
        this.setState(prevState => ({
            showStartModal: !prevState.showStartModal
        }))
    }

    toggleEndModal = () => {
        this.setState(prevState => ({
            showEndModal: !prevState.showEndModal
        }))
    }

    updateCanvas = (data) => {
        if (this.animating) return;
        const { presenterMeetingStore, sessionStore } = this.props;
        presenterMeetingStore.updateCanvas(sessionStore.authUser, data);
    }

    updateControl = (key, val) => {
        if (val !== undefined)  {
            this.setState({
                brushColor: val
            })
        }
    }

    undoChange = () => {
        if (this.canvas) {
            this.canvas.undo();
        }
    }

    
    clearCanvasDraw = () => {
        if (this.canvas) {
            this.canvas.clearScreen();
        }
    }

    render() {
        const { presenterMeetingStore, sessionStore } = this.props
        const { meeting } = presenterMeetingStore;
        const uiSlideNum = meeting.uid ? meeting.presentation.currentSlide + 1 : 1;
        const totalSlides = meeting.uid ? meeting.presentation.noOfSlides : 1;
        const { actualStartTime, actualEndTime } = meeting;
        const actualStartTimeUI = actualStartTime ? moment(actualStartTime).format('LLL') : '-';
        const actualEndTimeUI = actualEndTime ? moment(actualEndTime).format('hh:mm A') : '-';


        const noMeeting = <span>Loading Meeting</span>;
        let presentationSlide = null;
        const slide = meeting.uid ? meeting.presentation.slides[meeting.presentation.currentSlide] : {};
        if (meeting) {
            if (meeting.status !== 'STARTED')
                presentationSlide = (<div>
                    {slide ? <Slide slide={slide} device={this.state.device} updateCanvas={this.updateCanvas} status={meeting.status} brushColor={this.state.brushColor} /> : null}
                </div>);
            else if (meeting.status === 'STARTED') {
                presentationSlide = slide ? <Slide ref={slideCanvas => (this.canvas = slideCanvas)} slide={slide} device={this.state.device} updateCanvas={this.updateCanvas} status={meeting.status} brushColor={this.state.brushColor} /> : null;
            }
        } else {
            presentationSlide = noMeeting;
        }

        const remoteSlides = meeting.uid ? meeting.presentation.slides : [];
        const thumbs = remoteSlides.map((item, i) => {
            const active = i == meeting.presentation.currentSlide;
            return (
                <a key={i} onClick={(e) => {
                    this.goToIndex(i);
                }}>
                    <Thumb slide={item} index={i} active={active} />
                </a>
            )
        })
        const thumbSlider = <div className="thumb-container">
            <Badge id="prev" className="mr-1 mb-1"
                color="warning"
                onClick={this.previous}
            >
                <ChevronLeft size={20} />
                <UncontrolledTooltip placement="top" target="prev">
                    Previous Slide
                </UncontrolledTooltip>
            </Badge>
            <Badge id="next" className="mr-1 mb-1"
                color="warning"
                onClick={this.next}
            >
                <ChevronRight size={20} />
                <UncontrolledTooltip placement="top" target="next">
                    Next Slide
                </UncontrolledTooltip>
            </Badge>
            <div className="thumb-holder">
                {thumbs}
            </div>

        </div>

        const sliderSettings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false
        };

        const slickSlider = meeting.uid ? (
            <Slider {...sliderSettings} className="thumb-holder">
                {thumbs}
            </Slider>
        ) : null;

        const participants = meeting && meeting.participants ?
            meeting.participants.map((participant, i) =>
                <Participant key={i} participant={participant} />) : null;

        const controlToolbar = meeting.uid && meeting.status === 'STARTED' ? (<PresenterControls
                meeting={meeting}
                updateControl={this.updateControl}
                undo={this.undoChange}
                clear={this.clearCanvasDraw}
            />) : null;

        const startModal = (<Modal
            isOpen={this.state.showStartModal}
            toggle={this.toggleStartModal}
        >
            <ModalHeader toggle={this.toggleStartModal}>
                Start Meeting
            </ModalHeader>
            <ModalBody>
                <p>You are about to start your meeting.</p>
                {/* <p>Please select below option to start audio support</p> */}
                {/* <Checkbox
                    color="primary"
                    icon={<Check className="vx-icon" size={16} />}
                    label="Join Computer Audio"
                    defaultChecked={false}
                    value={this.state.audioOpted}
                    onClick={e=> this.setState({audioOpted: true})} /> */}

            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={this.startMeeting}>
                    Start Meeting Now
              </Button>{" "}
                <Button color="default" onClick={this.toggleStartModal}>
                    Close
              </Button>{" "}
            </ModalFooter>
        </Modal>)

        const endModal = (<Modal
            isOpen={this.state.showEndModal}
            toggle={this.toggleEndModal}
        >
            <ModalHeader toggle={this.toggleEndModal}>
                End Meeting
            </ModalHeader>
            <ModalBody>
                <p>Are you sure to end your meeting?</p>
                <Checkbox
                    color="primary"
                    icon={<Check className="vx-icon" size={16} />}
                    label="Ask Customer Feedback?"
                    defaultChecked={false}
                />
                <Checkbox
                    color="primary"
                    icon={<Check className="vx-icon" size={16} />}
                    label="Show Content Download Link?"
                    defaultChecked={false}
                />
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={this.toggleEndModal}>
                    Cancel
                </Button>
                <Button color="danger" onClick={this.endMeeting}>
                    End Meeting Now
                </Button>{" "}
            </ModalFooter>
        </Modal>)

        return (
            <React.Fragment>
                {startModal}
                {endModal}
                <div className="presenter-room">
                    <Row>
                        <a style={{ margin: 10 + 'px', width: 50 + 'px' }}>
                            <Badge color="primary"
                                onClick={e => history.goBack()}>
                                <ArrowLeftCircle size={16} />
                            </Badge>
                        </a>
                        <Col xs="11">
                            <Row>
                                <Col xs="12">
                                    <Card>
                                        <CardHeader>
                                            <CardTitle>
                                                Title: {meeting ? meeting.title + " ("+ uiSlideNum +"/"+ totalSlides +")" : null}
                                            </CardTitle>
                                            {controlToolbar}
                                            <div className="d-lg-block float-right">
                                                {meeting.status === 'SCHEDULED' || meeting.status === 'END' ?
                                                    <Button className="mr-1 mb-1 round" color="relief-success"
                                                        onClick={() => {
                                                            this.toggleStartModal();
                                                        }}>
                                                        <Power size={20} />
                                                        <span>Start</span>
                                                    </Button> : <Button className="mr-1 mb-1 round" color="relief-danger"
                                                        onClick={() => {
                                                            this.toggleEndModal();
                                                        }}>
                                                        <Power size={20} />
                                                        <span>End</span>
                                                    </Button>}
                                                {meeting.status === 'STARTED' ? <Timer from={meeting.actualStartTime} /> : null}
                                            </div>
                                        </CardHeader>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="9">
                                    <Row>
                                        <Col xs="12">
                                            <Card>
                                                <CardBody>
                                                    {/* <Badge color="primary" className="slide-counter">Slide# {uiSlideNum}</Badge> */}
                                                    <ButtonGroup>
                                                        <Button size="sm" outline={this.state.device != 'smartphone'} color="primary" id="smartphone"
                                                            onClick={e => { this.setState({ device: 'smartphone' }) }}>
                                                            <Smartphone size={20} />
                                                            <UncontrolledTooltip placement="top" target="smartphone">
                                                                SmartPhone
                                                            </UncontrolledTooltip>
                                                        </Button>
                                                        {/*<Button size="sm" outline={this.state.device != 'tablet'} color="primary" id="tablet"
                                                            onClick={e => { this.setState({ device: 'tablet' }) }}>
                                                            <CreditCard size={20} />
                                                            <UncontrolledTooltip placement="top" target="tablet">
                                                                Tablet
                                                            </UncontrolledTooltip>
                                                    </Button>*/}
                                                        <Button size="sm" outline={this.state.device != 'desktop'} color="primary" id="desktop"
                                                            onClick={e => { this.setState({ device: 'desktop' }) }}>
                                                            <Monitor size={20} />
                                                            <UncontrolledTooltip placement="top" target="desktop">
                                                                Desktop
                                                            </UncontrolledTooltip>
                                                        </Button>
                                                    </ButtonGroup>
                                                    {presentationSlide}
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="">
                                        <Col xs="12">
                                            <Card>
                                                <CardBody>
                                                    {slickSlider}
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="3">
                                    <Row>
                                        <Col xs="12">
                                            <Card>
                                                <CardHeader>
                                                    <CardTitle>
                                                        Participants {this.state.participantCollapsed ? null : `#${meeting.participants.length}`}
                                                    </CardTitle>
                                                    <div className="actions"
                                                        onClick={e => this.setState({ participantCollapsed: !this.state.participantCollapsed })}>
                                                        {this.state.participantCollapsed ? <ChevronDown
                                                            className="collapse-icon mr-50"
                                                            size={15}
                                                        /> : <ChevronUp
                                                                className="collapse-icon mr-50"
                                                                size={15}
                                                            />}
                                                    </div>
                                                </CardHeader>
                                                <CardBody className="participant-holder">
                                                    <Collapse isOpen={this.state.participantCollapsed}>
                                                        <ul className="participant-list">
                                                            {participants}
                                                        </ul>
                                                    </Collapse>
                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardHeader>
                                                    <CardTitle>
                                                        Notes
                                                    </CardTitle>
                                                    <div className="actions">
                                                        <ChevronDown
                                                            className="collapse-icon mr-50"
                                                            size={15}
                                                            onClick={e => this.setState({ notesCollapsed: !this.state.notesCollapsed })}
                                                        />
                                                    </div>
                                                </CardHeader>
                                                <CardBody>
                                                    <Collapse isOpen={this.state.notesCollapsed}>

                                                    </Collapse>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default PresenterMeetingRoomNew
